import React from "react";
import Card from "components/card/Card.js";
import {
  Box,
  Button,
  Flex,
  Select,
  FormLabel,
  Input,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useForm, Controller } from "react-hook-form";
import useAddEntity from "hooks/entityList/useAddEntity";
import useAddEntityLayout from "hooks/entityList/useAddEntityLayout";
import { STATE_NAMES } from "constants/globalConstants";
import useSavedForm from "hooks/useSavedForm";
import AddDynamicForm from "./addDynamicForm";

function AddEntityForm({ setShowAddForm }) {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  let activeColor = useColorModeValue("gray.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const buttonHover = useColorModeValue("brand.600", "brand.400");
  const { mutate: submitEntity, isLoading: isSubmitLoading } =
    useAddEntity(setShowAddForm);
  const { mutate: submitEntityLayout, isLoading: isLayoutLoading } =
    useAddEntityLayout();
  const { isLoading, error, data: savedFormData } = useSavedForm();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const generateStateOptions = () => {
    return STATE_NAMES?.map((state) => {
      return <option value={state.value}>{state.label}</option>;
    });
  };

  const getMultipleSelectValues = (array) => {
    var result = [];
    for (var i = 0; i < array.length; i += 1) {
      result.push(array[i]["value"]);
    }
    return result;
  };

  const onSubmit = (data) => {
    let metaData = [];
    if (data?.meta?.length > 0) {
      data?.meta?.map((data) => {
        Object.keys(data).forEach((key) => {
          metaData.push({
            label: key,
            value: Array.isArray(data[key])
              ? getMultipleSelectValues(data[key])
              : data[key],
            entity_field_id: savedFormData.data.filter(
              (formData) => formData.label === key
            )[0].id,
          });
        });
      });
    }
    submitEntity({
      name: data.name,
      slug: data.slug,
      Address: {
        long: data.long,
        lat: data.lat,
        city: data.city,
        pincode: data.pincode,
        state: data.state,
      },
      meta: metaData,
    });
  };

  const onError = (error) => {
    console.log(error);
  };

  const onSubmit2 = (data) => {
    let metaData = [];
    if (data?.meta?.length > 0) {
      data?.meta?.map((data) => {
        Object.keys(data).forEach((key) => {
          metaData.push({
            label: key,
            value: Array.isArray(data[key])
              ? getMultipleSelectValues(data[key])
              : data[key],
            entity_field_id: savedFormData.data.filter(
              (formData) => formData.label === key
            )[0].id,
          });
        });
      });
    }
    submitEntityLayout({
      name: data.name,
      slug: data.slug,
      Address: {
        long: data.long,
        lat: data.lat,
        city: data.city,
        pincode: data.pincode,
        state: data.state,
      },
      meta: metaData,
    });
  };

  return (
    <Box w="100%" pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        <Flex
          maxW={{ base: "100%" }}
          w="100%"
          mx={{ base: "auto", lg: "0px" }}
          me="auto"
          h="100%"
          alignItems="start"
          justifyContent="center"
          mb={{ base: "30px", md: "30px" }}
          px={{ base: "25px", md: "0px" }}
          mt={{ base: "20px", md: "20px" }}
          flexDirection="column"
        >
          <Flex alignItems="center" mb="24px" ms="4px">
            <Box
              onClick={() => setShowAddForm(false)}
              cursor="pointer"
              pr="10px"
            >
              <Icon as={ArrowBackIcon} w={6} h={6} />
            </Box>
            <Box me="auto">
              <Text color={activeColor} fontWeight="bold" fontSize="24px">
                Add Entity
              </Text>
            </Box>
          </Flex>
          <Flex
            direction="column"
            w="100%"
            maxW="100%"
            background="transparent"
            borderRadius="15px"
            mx={{ base: "auto", lg: "unset" }}
            me="auto"
            mb={{ base: "20px", md: "auto" }}
          >
            <form
              onSubmit={handleSubmit(onSubmit, onError(error))}
              style={{ width: "100%" }}
            >
              <Flex w="100%">
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Name<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="name"
                      rules={{
                        required: true,
                        maxLength: 50,
                        validate: (value) => {
                          return !!value.trim();
                        },
                      }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="name"
                          placeholder="Enter your name"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                    {errors.name?.type === "required" && (
                      <span style={{ color: "red" }}>name is required</span>
                    )}
                    {errors.name?.type === "validate" && (
                      <span style={{ color: "red" }}>name is required</span>
                    )}
                    {errors?.name?.type === "maxLength" && (
                      <span style={{ color: "red" }}>
                        max length exceeded which is 50
                      </span>
                    )}
                  </div>
                </Flex>
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Slug<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="slug"
                      rules={{
                        required: true,
                        maxLength: 50,
                        validate: (value) => {
                          return !!value.trim();
                        },
                      }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="name"
                          placeholder="Enter slug"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                    {errors.slug?.type === "required" && (
                      <span style={{ color: "red" }}>slug is required</span>
                    )}
                    {errors.slug?.type === "validate" && (
                      <span style={{ color: "red" }}>slug is required</span>
                    )}
                    {errors?.slug?.type === "maxLength" && (
                      <span style={{ color: "red" }}>
                        max length exceeded which is 50
                      </span>
                    )}
                  </div>
                </Flex>
              </Flex>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="lg"
                fontWeight="bold"
                color={textColor}
                mt="8px"
                mb="16px"
                ml="10px"
              >
                Address
              </FormLabel>
              <Flex w="100%">
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Latitude
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="lat"
                      rules={{ required: false }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="name"
                          placeholder="Enter Latitude"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                  </div>
                </Flex>
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    isRequired={false}
                    display="flex"
                  >
                    Longitude
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="long"
                      rules={{ required: false }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          placeholder="Enter Longitude"
                          size="lg"
                          type="name"
                          {...field}
                        />
                      )}
                    />
                  </div>
                </Flex>
              </Flex>
              <Flex w="100%">
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    City<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="city"
                      rules={{
                        required: true,
                        maxLength: 50,
                        validate: (value) => {
                          return !!value.trim();
                        },
                      }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="name"
                          placeholder="Enter your City"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                    {errors.city?.type === "required" && (
                      <span style={{ color: "red" }}>City is required</span>
                    )}
                    {errors.city?.type === "validate" && (
                      <span style={{ color: "red" }}>City is required</span>
                    )}
                    {errors.city?.type === "maxLength" && (
                      <span style={{ color: "red" }}>
                        max length exceeded which is 50
                      </span>
                    )}
                  </div>
                </Flex>
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    isRequired={true}
                    display="flex"
                  >
                    State<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="state"
                      rules={{ required: true }}
                      control={control}
                      render={({ field }) => (
                        <Select
                          id="user_type"
                          size="lg"
                          fontSize="14px"
                          placeholder="Select State"
                          {...field}
                        >
                          {generateStateOptions()}
                        </Select>
                      )}
                    />
                    {errors.state?.type === "required" && (
                      <span style={{ color: "red" }}>state is required</span>
                    )}
                  </div>
                </Flex>
              </Flex>
              <Flex w="50%">
                <Flex direction="column" width="100%" pl="10px">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Pin Code<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "24px" }}>
                    <Controller
                      name="pincode"
                      rules={{ required: true, maxLength: 6 }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="number"
                          placeholder="Enter Pin Code"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                    {errors.pincode?.type === "required" && (
                      <span style={{ color: "red" }}>Pin Code is required</span>
                    )}
                    {errors.pincode?.type === "maxLength" && (
                      <span style={{ color: "red" }}>
                        max length exceeded which is 6
                      </span>
                    )}
                  </div>
                </Flex>
              </Flex>
              {savedFormData?.data?.length > 0 ? (
                <AddDynamicForm
                  control={control}
                  errors={errors}
                  savedFormData={savedFormData}
                />
              ) : null}
              <Flex width="50%" mt="20px" pl="10px">
                <Button
                  fontSize="sm"
                  variant="brand"
                  fontWeight="500"
                  w="40%"
                  h="50"
                  mb="24px"
                  mr="20px"
                  type="submit"
                  isLoading={isSubmitLoading}
                  _hover={{ bg: isSubmitLoading ? "blue" : buttonHover }}
                >
                  Save
                </Button>
                <Button
                  fontSize="sm"
                  variant="brand"
                  fontWeight="500"
                  w="50%"
                  h="50"
                  mb="24px"
                  px="50px"
                  mr="20px"
                  isLoading={isLayoutLoading}
                  _hover={{ bg: isLoading ? "blue" : buttonHover }}
                  type="button"
                  onClick={handleSubmit(onSubmit2)}
                >
                  Save and Plan Layout
                </Button>
                <Button
                  fontSize="sm"
                  variant="brand"
                  fontWeight="500"
                  w="40%"
                  h="50"
                  mb="24px"
                  onClick={() => setShowAddForm(false)}
                >
                  Cancel
                </Button>
              </Flex>
            </form>
          </Flex>
        </Flex>
      </Card>
    </Box>
  );
}

export default AddEntityForm;
